import { Autocomplete, Grid, TextField } from "@mui/material";
import Disabled from "components/common/Disabled";
import * as config from "config";
import { useDispatch, useSelector } from "react-redux";
import * as staticDataService from "services/staticDataService";
import * as claimsActions from "store/actions/input/claims/claimsActions";

const ConfiguredClaimsFields = () => {
  const dispatch = useDispatch();
  const claimsFields = useSelector(
    (state) => state.input?.claims?.fields ?? {}
  );
  const { data: claimsConfig } = staticDataService.useConfigQuery(
    "claims_config"
  );

  const configFields = claimsConfig?.fields;
  const enums = claimsConfig?.enums ?? {};

  if (!configFields?.length) return null;

  const isVisible = (field) =>
    !field.showIf || claimsFields?.[field.showIf.key] === field.showIf.value;

  return (
    <Grid container spacing={config.GRID_SPACING}>
      {configFields.filter(isVisible).map((field) => {
        const choices = field.choices ?? enums[field.enumKey]?.choices ?? [];
        return (
          <Grid item xs={12} sm={6} key={field.key}>
            <Disabled ifReadOnly>
              <Autocomplete
                value={
                  choices.find((c) => c.key === claimsFields?.[field.key]) ??
                  null
                }
                options={choices}
                getOptionLabel={(o) => o.name}
                onChange={(_, option) =>
                  dispatch(
                    claimsActions.updateClaimsFields({
                      [field.key]: option?.key ?? null,
                    })
                  )
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={field.label}
                    variant={"filled"}
                    InputLabelProps={{ shrink: true }}
                  />
                )}
                autoHighlight
              />
            </Disabled>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default ConfiguredClaimsFields;
